export const API_URL = `${process.env.REACT_APP_API_URL}`;
export const LOCAL_STORAGE_JWT = "SEVOLUTION.JWT";
export const LOCAL_STORAGE_PROFILE = "SEVOLUTION.LOCAL_STORAGE_PROFILE";
